export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-3.5e2164d1.png";